<!--  -->
<template>
  <div class="djawrw">
    <div class="searchbox">
      <el-input
        v-model="parameter.keyword"
        style="width: 180px;"
        placeholder="请输入内容"
        class="select_box"
      ></el-input>
      <el-input
        v-model="parameter.video_name"
        style="width: 180px;"
        placeholder="请输入视频名称"
        class="select_box"
      ></el-input>
      <el-date-picker
        v-model="subscribetime"
        style="width:300px"
        format="yyyy-MM-dd"
        value-format="yyyyMMdd"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :clearable="false"
        @change="timechanger"
        :picker-options="pickerOptions"
        class="select_box"
      />
      <el-select
        class="select_box"
        style="width:180px"
        v-model="parameter.all_data"
        placeholder="视频数据汇总"
      >
        <el-option
          v-for="item in videodata_options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-select
        class="select_box"
        style="width:180px"
        v-model="parameter.play_time"
        placeholder="播放时间升序/降序"
      >
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-select
        class="select_box"
        style="width:180px"
        v-model="parameter.click_number"
        placeholder="点击数量升序/降序"
      >
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-select
        class="select_box"
        style="width:180px"
        v-model="parameter.forward_number"
        placeholder="转发数量升序/降序"
      >
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-select
        class="select_box"
        style="width:180px"
        v-model="parameter.pull_ad"
        placeholder="广告拉取数量升序/降序"
      >
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-select
        class="select_box"
        style="width:180px"
        v-model="parameter.ad_view_number"
        placeholder="广告观看完成数量升序/降序"
      >
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-select
        class="select_box"
        style="width:180px"
        v-model="parameter.play_number"
        placeholder="播放数量升序/降序"
      >
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-button
        size="mini"
        type="primary"
        icon="el-icon-search"
        @click="search"
      >搜索</el-button>
      <el-button
        size="mini"
        type="info"
        icon="el-icon-refresh"
        @click="reset"
      >重置</el-button>
    </div>
    <el-table
      v-loading="loading"
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="id"
        label="id"
        width="55"
        align="center"
      />
      <el-table-column
        prop="accounts_name"
        label="小程序名称"
        width="200"
        align="center"
      />
      <el-table-column
        prop="app_id"
        label="小程序appid"
        width="200"
        align="center"
      />
      <el-table-column
        prop="video_name"
        label="视频名称"
        width="400"
        align="center"
      >
        <template slot-scope="scope">
          <el-tooltip placement="top">
            <div slot="content">{{ scope.row.video_name }}</div>
            <div class="ellipsis">{{ scope.row.video_name }}</div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        prop="statistical_date_text"
        label="记录日期"
        width="130"
        align="center"
      />
      <el-table-column
        prop="play_time_text"
        label="播放时间"
        width="100"
        align="center"
      />
      <el-table-column
        prop="click_number"
        label="点击数量"
        width="100"
        align="center"
      />
      <el-table-column
        prop="forward_number"
        label="转发数量"
        width="100"
        align="center"
      />
      <el-table-column
        prop="pull_ad"
        label="广告拉取数量"
        width="130"
        align="center"
      />
      <el-table-column
        prop="ad_view_number"
        label="广告观看完成数量"
        width="150"
        align="center"
      />
      <el-table-column
        prop="play_number"
        label="播放数量"
        align="center"
      />
      <!-- <el-table-column
        prop="create_at_text"
        label="创建时间"
        width="200"
        align="center"
      /> -->
    </el-table>
    <pagination-right
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import { videoSettingstatistics } from '@/api/sourceminiprogram.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  name: 'blessingVideohistory',
  components: { PaginationRight },
  data() {
    return {
      video_id: null,
      total: null,
      parameter: {
        page: 1,
        page_size: 10,
        keyword: '',
        video_name: '',
        all_data: '',
        start_date: '',
        end_date: '',
        play_time: '', //播放时间  1升序 2降序
        click_number: '', //点击数量  1升序 2降序
        forward_number: '', //转发数量  1升序 2降序
        pull_ad: '', //广告拉取数量1升序 2降序
        ad_view_number: '', //广告观看完成数量 1升序 2降序
        play_number: '' //播放数量 1升序 2降序
      },
      tableData: [],
      loading: false,
      subscribetime: [],
      options: [
        {
          value: 1,
          label: '升序'
        },
        {
          value: 2,
          label: '降序'
        }
      ],
      videodata_options: [
        {
          value: '',
          label: '正常'
        },
        {
          value: 1,
          label: '汇总'
        }
      ],
      pickerOptions: {
        // 禁用当前日期之前的日期
        disabledDate(time) {
          // Date.now()是javascript中的内置函数，它返回自1970年1月1日00:00:00 UTC以来经过的毫秒数。
          return time.getTime() > Date.now()
        }
      }
    }
  },
  created() {
    // console.log('this.$route.query.id1', this.$route.query.id)
    // this.video_id = this.$route.query.id
    // this.gettlist()
  },
  activated() {
    console.log('this.$route.query.id2', this.$route.query.id)
    if (this.$route.query.id !== undefined) {
      this.video_id = this.$route.query.id
    }
    this.gettlist()
  },
  mounted() {},
  methods: {
    // send(video_id) {
    //   this.video_id = video_id
    //   this.gettlist()
    // },
    gettlist() {
      this.loading = true
      videoSettingstatistics({ ...this.parameter, video_id: this.video_id }).then(res => {
        console.log('res', res.data.list)
        this.loading = false
        this.total = res.data.total
        this.tableData = res.data.list
      })
    },
    fetchPageSize(e) {
      this.parameter.page_size = e
      this.gettlist()
    },

    fetchCurrentPage(e) {
      this.parameter.page = e
      this.gettlist()
    },
    timechanger(val) {
      this.parameter.start_date = val[0]
      this.parameter.end_date = val[1]
      console.log('val', val)
    },
    search() {
      this.parameter.page = 1
      this.gettlist()
    },
    reset() {
      this.parameter = {
        page: 1,
        page_size: 10,
        keyword: '',
        video_name: '',
        all_data: '',
        start_date: '',
        end_date: '',
        play_time: '', //播放时间  1升序 2降序
        click_number: '', //点击数量  1升序 2降序
        forward_number: '', //转发数量  1升序 2降序
        pull_ad: '', //广告拉取数量1升序 2降序
        ad_view_number: '', //广告观看完成数量 1升序 2降序
        play_number: '' //播放数量 1升序 2降序
      }
      // this.video_id = null
      this.subscribetime = []
      this.gettlist()
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.searchbox {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.select_box {
  margin-right: 10px;
}
.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.djawrw {
  padding: 30px;
}
</style>